import Avatar from '-/Custom/Avatar';
import type { ReactElement, ReactNode } from 'react';
import { StyleSheet } from 'react-native-unistyles';
import Section, { SectionHeading } from '@/components/UI/Section';
import Text from '@/components/UI/Text';
import Box from '@/components/Unistyles/Box';

export type PersonManagerSummary = {
  avatarId?: string | null;
  color?: string | null;
  id: string;
  name: string;
};

type PersonManagersSectionProps = {
  actionPlacement?: 'inline' | 'end';
  emptyContent?: ReactElement | null;
  actions?: ReactNode;
  managers: readonly PersonManagerSummary[];
  testID: string;
};

export default function PersonManagersSection({
  emptyContent,
  actions,
  actionPlacement,
  managers,
  testID,
}: PersonManagersSectionProps) {
  return (
    <Section testID={testID}>
      <SectionHeading
        title="Managers"
        actions={actions}
        actionPlacement={actionPlacement}
      />
      <Box
        direction="vertical"
        style={managers.length ? styles.card : undefined}
      >
        {managers.map((manager, index) => (
          <Box
            direction="vertical"
            key={manager.id}
            space="md"
            style={styles.managerRow(index < managers.length - 1)}
          >
            <Box align="center" direction="horizontal" space="md">
              <Avatar
                id={manager.avatarId ?? ''}
                color={manager.color ?? ''}
                name={manager.name}
                size="sm"
              />
              <Box flex>
                <Text size="sm">{manager.name}</Text>
              </Box>
            </Box>
          </Box>
        ))}
        {emptyContent}
      </Box>
    </Section>
  );
}

const styles = StyleSheet.create((theme) => ({
  card: {
    backgroundColor: theme.colors.surface,
    borderColor: theme.colors.borderMuted,
    borderCurve: 'continuous',
    borderRadius: theme.borderRadius.lg,
    borderWidth: StyleSheet.hairlineWidth,
    overflow: 'hidden',
  },
  managerRow: (showBorder: boolean) => ({
    borderBottomColor: theme.colors.borderMuted,
    borderBottomWidth: showBorder ? StyleSheet.hairlineWidth : 0,
    paddingHorizontal: theme.space(3),
    paddingVertical: theme.space(2),
  }),
}));
